module.exports = __webpack_public_path__ + "media/6.1f85c6c6.mp3";